import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React, { useState } from 'react';
import { Link as Link$1 } from 'react-router-dom';
import { node, string, shape, oneOfType, bool, func, oneOf } from 'prop-types';
import { Heading, StatusMessage, Text, Tooltip, Link, Icon } from '@tesla/design-system-react';
import { iconChevron270 } from '@tesla/design-system-icons';
import styles from './styles.module.css.js';

var propTypes = {
  children: node,
  titleText: string,
  subtitleText: string,
  subtitleWithTooltip: shape({
    subtitleTextWithTooltip: string,
    tooltipText: string,
    setTooltipText: string
  }),
  backButtonText: string,
  backButtonUrl: oneOfType([string, shape({
    pathname: string,
    search: string,
    hash: string,
    state: shape({})
  })]).isRequired,
  externalUrl: bool,
  backButtonOnClick: func,
  statusMessage: bool,
  messageType: oneOf(['info', 'warning', 'error', 'success']),
  messageEnclosed: bool,
  messageText: string
};
var defaultProps = {
  children: null,
  titleText: '',
  backButtonText: '',
  externalUrl: false,
  subtitleText: '',
  subtitleWithTooltip: {
    subtitleTextWithTooltip: '',
    tooltipText: '',
    setTooltipText: ''
  },
  backButtonOnClick: function backButtonOnClick() {},
  statusMessage: false,
  messageType: 'info',
  messageEnclosed: false,
  messageText: ''
};
var MainTitle = function MainTitle(_ref) {
  var children = _ref.children,
    titleText = _ref.titleText,
    subtitleText = _ref.subtitleText,
    _ref$subtitleWithTool = _ref.subtitleWithTooltip,
    subtitleTextWithTooltip = _ref$subtitleWithTool.subtitleTextWithTooltip,
    tooltipText = _ref$subtitleWithTool.tooltipText,
    setTooltipText = _ref$subtitleWithTool.setTooltipText,
    backButtonText = _ref.backButtonText,
    backButtonUrl = _ref.backButtonUrl,
    externalUrl = _ref.externalUrl,
    backButtonOnClick = _ref.backButtonOnClick,
    statusMessage = _ref.statusMessage,
    messageType = _ref.messageType,
    messageEnclosed = _ref.messageEnclosed,
    messageText = _ref.messageText;
  var _useState = useState(tooltipText),
    _useState2 = _slicedToArray(_useState, 2),
    tooltipContent = _useState2[0],
    setTooltipContent = _useState2[1];
  var copyToClipboard = function copyToClipboard() {
    var _document$getElementB = document.getElementById('subtitleTextWithTooltip'),
      textContent = _document$getElementB.textContent;
    var textArea = document.createElement('textarea');
    textArea.value = textContent === null || textContent === void 0 ? void 0 : textContent.split(' ').pop();
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    setTooltipContent(setTooltipText);
    textArea.remove();
  };
  var externalLinkElem = /*#__PURE__*/React.createElement("div", {
    className: styles.BackLink
  }, /*#__PURE__*/React.createElement(Link, {
    href: backButtonUrl,
    variant: "secondary",
    onClick: backButtonOnClick,
    "data-test": "main-title-back-button",
    className: "tds-link--icon-leading"
  }, /*#__PURE__*/React.createElement(Icon, {
    data: iconChevron270
  }), " ", /*#__PURE__*/React.createElement("span", null, backButtonText)));
  var reactLinkElem = /*#__PURE__*/React.createElement("div", {
    className: styles.BackLink
  }, /*#__PURE__*/React.createElement(Link$1, {
    to: backButtonUrl,
    className: "tds-link tds-link--secondary tds-link--icon-leading",
    onClick: backButtonOnClick,
    "data-test": "main-title-back-button"
  }, /*#__PURE__*/React.createElement(Icon, {
    data: iconChevron270
  }), " ", /*#__PURE__*/React.createElement("span", null, backButtonText)));
  var renderLink = function renderLink() {
    if (backButtonText) {
      return externalUrl ? externalLinkElem : reactLinkElem;
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.Container,
    "data-test": "main-title"
  }, renderLink(), /*#__PURE__*/React.createElement("div", {
    className: styles.Title
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.TitleHeader
  }, /*#__PURE__*/React.createElement(Heading, {
    is: "h1",
    className: "".concat(backButtonText ? styles['TitleText--NoPadding'] : ''),
    "data-test": "main-title-text"
  }, titleText), statusMessage && /*#__PURE__*/React.createElement("div", {
    "data-test": "main-title-status"
  }, /*#__PURE__*/React.createElement(StatusMessage, {
    type: messageType,
    enclosed: messageEnclosed,
    body: messageText
  })), subtitleText && /*#__PURE__*/React.createElement(Text, {
    weight: "regular",
    contrast: "medium",
    "data-test": "main-title-subtext"
  }, subtitleText), subtitleTextWithTooltip ? /*#__PURE__*/React.createElement("div", {
    className: "tds-text--regular tds-tooltip-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: copyToClipboard,
    "data-tds-tooltip-trigger": true,
    inline: true
  }, /*#__PURE__*/React.createElement(Text, {
    is: "p",
    contrast: "medium",
    id: "subtitleTextWithTooltip"
  }, subtitleTextWithTooltip)), /*#__PURE__*/React.createElement(Tooltip, {
    className: styles.TooltipContent
  }, tooltipContent)) : null), children && /*#__PURE__*/React.createElement("div", {
    className: styles.SideLink
  }, children)));
};
MainTitle.propTypes = propTypes;
MainTitle.defaultProps = defaultProps;

export { MainTitle as default };
